import React, {useState} from 'react'


function MultiLineField({fieldObj, fieldIndex, fieldUpdatedFunction, singleLocationMode, readOnly}){
    const [text, setText] = useState(singleLocationMode || readOnly ? fieldObj.text : "")

    const textChanged = (event) => {
        fieldObj.text = event.target.value
        setText(event.target.value)
        fieldUpdatedFunction(fieldObj)
    }

    const isDisabled = () => {
        if(readOnly){
            return true
        } else {
            singleLocationMode ? false : !fieldObj.bulkAllowed
        }
    }

    return(
        <div>
            <textarea className="form-control text-area border"
                      key={"input -" + fieldObj.fieldId + fieldIndex}
                      value={text}
                      onChange={e => textChanged(e)}
                      placeholder={"Enter " + fieldObj.fieldDisplayName}
                      maxLength={fieldObj.maxCharacters}
                      disabled = {isDisabled()}
            />
        </div>
    )

}

export default MultiLineField;
